/*
 *   File : list.js
 *   Author : https://evoqins.com
 *   Description : list page 
 *   Integrations : 'NA'
 *   Version : 1.0.0
*/

// custom packages
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { format, setDate } from 'date-fns';
import { Modal } from 'bootstrap/dist/js/bootstrap.min';
import { useSelector } from 'react-redux';

// custom components
import { APIService } from '../../Service';
import { Chip, CustomTab } from '../../Components/Others';
import { CustomDatePicker, CustomSearchInput, CustomSelectBox, DateRangePicker } from '../../Components/FormElements';
import { PrimaryButton, SecondaryButton, TextButton } from '../../Components/Buttons';
import { CustomDataTable } from '../../Components/DataTable';
import { Icon } from '../../Components/Icon';
import { AcceptModal, ConfirmModal, CreateUserGroup, RejectModal, SuccessModal, ViewDetailModal } from '../../Components/Modal';
import EmptyScreen from '../../Components/Others/empty-screen';

// custom styles
import color from '../../Style/color.scss';

// const TAB_TITLES = [
//     { id: 1, type: "invested", label: 'Invested', tooltip: false },
//     { id: 2, type: "non_invested", label: 'Non-Invested', tooltip: true, tooltipContent: 'User who created investment account and didn’t invested yet' },
//     { id: 3, type: "signed_up", label: 'Signed-up', tooltip: true, tooltipContent: 'User who signed up and left before creating investment account' },
//     { id: 4, type: "fresh_kyc_submitted", label: 'Fresh KYC submitted', tooltip: true, tooltipContent: 'User who we have recently submitted their KYC documents' },
//     { id: 5, type: "bank_verification_list", label: 'Bank verification list', tooltip: false },
//     { id: 6, type: "user_group", label: 'User groups', tooltip: false }

// ];

const TAB_TITLES = [
    { id: 1, type: "all_customer", label: 'All Customers', tooltip: false },
    { id: 2, type: "user_group", label: 'User groups', tooltip: false },
    { id: 3, type: "bank_verification_list", label: 'Bank verification list', tooltip: false },

];

const ITEMS_PER_PAGE = 10;
const getNormalizedTabId = (tabId) => {
    const parsedTabId = Number(tabId);
    return Number.isNaN(parsedTabId) ? null : parsedTabId;
};

const List = () => {




    const { state } = useLocation();
    const isInitializedRef = useRef(false);
    const isClearRef = useRef(false);
    const scrollRef = useRef(null);
    const navigate = useNavigate();
    const PROFILE_DATA = useSelector((store) => store.Reducer.PROFILE_DATA);

    const [selectedTab, setSelectedTab] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);

    const [selectedType, setSelectedType] = useState("all_customer");

    const [selectedKycStatus, setSelectedKycStatus] = useState(null);
    const [customerCategory, setCustomerCategory] = useState(null);
    const [customerType, setCustomerType] = useState(null);

    const [searchValue, setSearchValue] = useState("");

    const [filterBtn, setFilterBtn] = useState(false);
    const [loader, setLoader] = useState(true);
    const [filterLoader, setFilterLoader] = useState(false);
    const [acceptModal, setAcceptModal] = useState(false);
    const [rejectModal, setRejectModal] = useState(false);
    const [proofModal, setProofModal] = useState(false);
    const [searched, setSearched] = useState(false);

    const [selectedDate, setSelectedDate] = useState(null);

    const [filterData, setFilterData] = useState({});

    const [listData, setListData] = useState({});
    const [selectedRow, setSelectedRow] = useState({});

    const [checked, setChecked] = useState([]);
    const [downloadLoader, setDownloadLoader] = useState(false);

    const [rejectSuccess, setRejectSuccess] = useState(false);
    const [rejectLoader, setRejectLoader] = useState(false);

    const [createGroupModal, setCreateGroupModal] = useState(false);
    const [createGroupSuccess, setCreateGroupSuccess] = useState(false);
    const [groupName, setGroupName] = useState("");

    const [groupData, setGroupData] = useState({});
    const [userGroupLoader, setUserGroupLoader] = useState(true);
    const [groupCurrentPage, setGroupCurrentPage] = useState(1);

    const [userGroupId, setUserGroupId] = useState(null);

    const [createGroupType, setCreateGroupType] = useState(1);
    const [successMessage, setSuccessMessage] = useState("");
    const [buttonLoader, setButtonLoader] = useState(false);
    const [confirmStatus, setConfirmStatus] = useState(false);

    const [selectedUsers, setSelectedUsers] = useState([]);
    const [groupType, setGroupType] = useState(1);

    const [selectedStatus, setSelectedStatus] = useState(null);
    const [selectedUserType, setSelectedUserType] = useState(null);

    const [verificationFilterData, setVerificationFilterData] = useState({});
    const [verificationFilterLoader, setVerificationFilterLoader] = useState(false);

    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteStatus, setDeleteStatus] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [deleteLoader, setDeleteLoader] = useState(false);
    const [tabTitles, setTabTitles] = useState(TAB_TITLES);

    const hasCustomerDownloadAccess = PROFILE_DATA?.modules?.some(
        (module) => module?.name?.toLowerCase() === "customer download"
    );

    const moduleBasedTabs = () => {
        if (!PROFILE_DATA?.modules?.length) return TAB_TITLES;

        const normalizedModules = PROFILE_DATA.modules.map(mod => mod?.name?.toLowerCase());

        return TAB_TITLES.filter((tab) => {
            if (tab.type === "all_customer") {
                return normalizedModules.includes("customer");
            }
            if (tab.type === "user_group") {
                return normalizedModules.includes("user group");
            }
            if (tab.type === "bank_verification_list") {
                return normalizedModules.includes("bank verification");
            }
            return false;
        });
    };

    const getDefaultTab = (tabs) => tabs?.[0] || TAB_TITLES[0];

    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth'
        });
    }, []);

    console.log("selectedTab", selectedTab);


    useEffect(() => {
        if (createGroupModal === true) {
            const modal = new Modal(document.getElementById("create-group-modal"));
            modal.show();
        }
    }, [createGroupModal]);

    useEffect(() => {
        if (createGroupSuccess === true) {
            const modal = new Modal(document.getElementById("success-modal"));
            modal.show();
        }
    }, [createGroupSuccess]);

    useEffect(() => {
        if (deleteModal === true) {
            const confirm_modal = new Modal(document.getElementById('confirm-modal'));
            confirm_modal.show();
        }
    }, [deleteModal]);


    useEffect(() => {
        if (isInitializedRef.current === false) {
            _filterData();
            _verificationFilterData();

            isInitializedRef.current = true;
        }
    }, []);

    useEffect(() => {
        const allowedTabs = moduleBasedTabs();
        setTabTitles(allowedTabs);
        const normalizedSelectedTab = getNormalizedTabId(selectedTab);

        if (normalizedSelectedTab === null || !allowedTabs.some(tab => tab.id === normalizedSelectedTab)) {
            const firstAllowedTab = getDefaultTab(allowedTabs);
            setSelectedTab(firstAllowedTab.id);
            setSelectedType(firstAllowedTab.type);
        }
    }, [PROFILE_DATA]);

    useEffect(() => {
        const normalizedSelectedTab = getNormalizedTabId(selectedTab);
        const isAllowedSelectedTab = tabTitles.some(tab => tab.id === normalizedSelectedTab);

        if (!normalizedSelectedTab || normalizedSelectedTab === 0) return;

        if (!isAllowedSelectedTab) {
            const defaultAllowedTab = getDefaultTab(tabTitles);
            setSelectedTab(defaultAllowedTab.id);
            setSelectedType(defaultAllowedTab.type);
            return;
        }

        if (normalizedSelectedTab === 1) {
            _userList();
        } else if (normalizedSelectedTab === 2) {
            _listGroup();
        } else {
            _bankVerificationList();
        }

        isClearRef.current = false;
    }, [selectedTab, tabTitles, isClearRef.current]);

    useEffect(() => {
        _handleBackdrop();
        window.addEventListener('popstate', _handleBackdrop);
        return () => {
            window.removeEventListener('popstate', _handleBackdrop);
        };
    }, [selectedTab]);

    function _handleBackdrop() {
        setProofModal(false);
        setAcceptModal(false);
        setRejectModal(false);
        if (document.querySelector(".modal-backdrop")) {
            document.querySelector(".modal-backdrop").remove();
            document.body.style.overflow = 'unset';
        };
    };

    useEffect(() => {
        if (acceptModal === true) {
            const accept_modal = new Modal(document.getElementById('accept-modal'));
            accept_modal.show();
        }
    }, [acceptModal]);

    useEffect(() => {
        if (rejectModal === true) {
            const reject_modal = new Modal(document.getElementById('reject-modal'));
            reject_modal.show();
        }
    }, [rejectModal]);

    useEffect(() => {
        if (proofModal === true) {
            const proof_modal = new Modal(document.getElementById('proof-modal'))
            proof_modal.show();
        }
    }, [proofModal]);


    useEffect(() => {
        const defaultAllowedTab = getDefaultTab(tabTitles);
        const normalizedStateTab = getNormalizedTabId(state?.tab_index);

        if (state !== null) {
            if (normalizedStateTab !== null) {
                const isAllowedTab = tabTitles.some(tab => tab.id === normalizedStateTab);
                setSelectedTab(isAllowedTab ? normalizedStateTab : defaultAllowedTab.id);
            } else {
                setSelectedTab(defaultAllowedTab.id);
            }
            if (state.type) {
                const isAllowedType = tabTitles.some(tab => tab.type === state.type);
                setSelectedType(isAllowedType ? state.type : defaultAllowedTab.type)
            } else {
                setSelectedType(defaultAllowedTab.type);
            }
            if (state.current_page) {
                setCurrentPage(state.current_page);
            } else {
                setCurrentPage(1);
            }

            if (state.search) {
                setSearchValue(state.search);
                setSearched(true);
            }

            if (state.group_name) {
                setGroupName(state.group_name);
            }

            if (state.group_id) {
                setUserGroupId(state.group_id);
            }
            if (state.checked) {
                setChecked(state.checked);
            }

            if (state.customer_category) {
                setCustomerCategory(state.customer_category)
            }

            if (state.customer_type) {
                setCustomerType(state.customer_type);
            }

            if (state.kyc_status) {
                setSelectedKycStatus(state.kyc_status);
            }

            if (state.selected_date) {
                setSelectedDate(state.selected_date)
            }

            if (state.toggle) {
                setFilterBtn(state.toggle)
            }

        } else {
            setSelectedTab(defaultAllowedTab.id);
            setCurrentPage(1);
            setGroupCurrentPage(1);
            setSelectedType(defaultAllowedTab.type);
        }
    }, [state, tabTitles]);

    const _toggleAllRows = () => {
        setIsSelectAll(prev => !prev);
        setChecked([]);

        // const current_ids = listData?.data?.map(row => row.customer_id);
        // const new_checked_ids = [...checked];

        // const updated_selected = current_ids.every(id => checked.includes(id));

        // if (updated_selected) {
        //     setChecked(new_checked_ids.filter(id => !current_ids.includes(id)));
        // } else {
        //     setChecked(Array.from(new Set([...new_checked_ids, ...current_ids])));
        // }
    };

    const _handleChecked = (customer_id) => {

        if (isSelectAll) {
            setIsSelectAll(false);
        }


        setChecked(prev => {
            if (prev.includes(customer_id)) {
                return prev.filter(id => id !== customer_id);
            } else {
                return [...prev, customer_id]
            }
        })
    };

    // handle clear date
    const _handleClearDate = () => {
        setSelectedDate(null);
    };

    // handle filter
    const _handleFilter = () => {
        setFilterBtn(!filterBtn);
    };

    // handle table page change 
    const _handleTablePageChange = (page_num) => {
        setLoader(true);

        if (selectedTab === 1) {
            _userList(page_num);
        } else {
            _bankVerificationList(page_num);
        }
        setCurrentPage(page_num);

        setTimeout(() => {
            if (scrollRef.current) {
                scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
            }
        }, 300);
    };

    // handle table page change 
    const _handleGroupTablePageChange = (page_num) => {
        _listGroup(page_num);
        setGroupCurrentPage(page_num);
        setUserGroupLoader(true);

        setTimeout(() => {
            if (scrollRef.current) {
                scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
            }
        }, 300);
    };

    // handle tab
    const _handleTab = (tab_id, type) => {
        navigate("/customers", {
            state: {
                tab_index: tab_id,
                type: type,
                group_name: state?.group_name
            }
        });


        setUserGroupLoader(true);
        setLoader(true);
        setChecked([]);
        setGroupCurrentPage(1);

        setSelectedDate(null);
        setSearchValue("");


        if (Object.keys(filterData).length !== 0) {
            setSelectedKycStatus(filterData?.kyc_status[0]);
            setCustomerCategory(filterData?.customer_category[0]);
            setCustomerType(filterData?.customer_type[0]);
        }

        if (Object.keys(verificationFilterData).length !== 0) {
            setSelectedStatus(verificationFilterData?.status[0]);
            setSelectedUserType(verificationFilterData?.nri_status[0]);
        }

        setCurrentPage(1);
        setFilterBtn(false);
    };

    // handle navigate detail 
    const _handleDetail = (customer_id) => {
        navigate(`${customer_id}`, {
            state: {
                source: "normal_listing",
                type: selectedType,
                search: searchValue,
                current_page: currentPage,

                customer_category: customerCategory,
                customer_type: customerType,
                kyc_status: selectedKycStatus,
                selected_date: selectedDate,
                toggle: filterBtn
            }
        });
    };

    // handle clear filter
    const _handleClear = () => {
        if (selectedTab === 1) {
            setLoader(true);
            _handleClearDate();

            setCustomerCategory(filterData?.customer_category[0]);
            setCustomerType(filterData?.customer_type[0]);
            // setKycCategory(filterData?.kyc_category[0]);
            setSelectedKycStatus(filterData?.kyc_status[0]);

            navigate(`/customers`, {
                state: {
                    ...state,
                    customer_category: filterData?.customer_category[0],
                    customer_type: filterData?.customer_type[0],
                    kyc_status: filterData?.kyc_status[0],
                    selected_date: null
                }
            });
        } else {
            setSelectedStatus(verificationFilterData.status[0]);
            setSelectedUserType(verificationFilterData.nri_status[0]);
        }

        isClearRef.current = true;
    };

    // handle selected filter
    const _handleFilterSelected = () => {
        setLoader(true);
        setCurrentPage(1);

        if (selectedTab === 1) {
            _userList(1);
        } else {
            _bankVerificationList(1);
        }
    };

    // on search click
    const _onSearch = () => {
        setSearched(true);
        setLoader(true);

        if (selectedTab === 1) {
            _userList(1);
        } else {
            _bankVerificationList(1);
        }
    };

    // handle search clear
    const _handleSearchClear = () => {
        setSearched(false);
        setSearchValue("");

        navigate(`/customers`, {
            state: {
                ...state,
                search: "",
            }
        });
        if (searched === true) {
            setLoader(true);

            if (selectedTab === 1) {
                _userList(currentPage, "")
            } else {
                _bankVerificationList(currentPage, "");
            }
        }
    };


    // handle download list
    const _downloadListUser = () => {
        _downloadList();
    };


    // handle create group
    const _handleCreateGroup = (group_type) => {
        setGroupType(group_type);
        setCreateGroupModal(true);
        setChecked([]);
    };

    const _handleCreate = () => {

        if (isSelectAll === false && checked.length === 0) {
            toast.dismiss();
            toast.error("Please select users before creating group.", { type: "error" });
        } else {
            _createGroup(groupName);
        }

    };

    // handle continue create group to get group name 
    const _handleContinue = (group_name, users) => {

        if (selectedTab === 2 && createGroupType === 1) {
            _handleTab(1, 'all_customer');
            setGroupName(group_name);

            navigate("/customers", {
                state: {
                    tab_index: 1,
                    type: 'all_customer',
                    path: "/customers"
                }
            });
            setCreateGroupModal(false);
            toast.dismiss();
            toast.success("Please select users to create group", { type: "success" });
        } else {
            _addUsers(users);
        }
    };


    // handle add users more
    const _handleAddUsers = (data, users) => {

        setCreateGroupModal(true);

        setUserGroupId(data.id);
        setGroupName(data.name);
        setSelectedUsers(data.data);

        setCreateGroupType(2);

        // if (users !== undefined) {
        //     let updated_user_ids = users?.map(item => item.id);
        //     setChecked(updated_user_ids);
        // } else {
        //     setChecked([]);
        // }
    };

    const [isSelectAll, setIsSelectAll] = useState(false);


    // Pending request data table column 
    const ALL_CUSTOMER = [
        ...(groupName.length > 0
            ? [
                {
                    name: (
                        listData?.data?.length > 0 && (
                            <Icon
                                icon={
                                    isSelectAll || listData.data.every(row => checked.includes(row.customer_id))
                                        ? "checkbox-active"
                                        : "checkbox-inactive"
                                }
                                size={16}
                                className="cursor-pointer"
                                onClick={_toggleAllRows}
                            />
                        )
                    ),
                    cell: (row) => (
                        <Icon
                            icon={
                                isSelectAll || checked.includes(row.customer_id)
                                    ? "checkbox-active"
                                    : "checkbox-inactive"
                            }
                            size={16}
                            className="cursor-pointer"
                            onClick={() => _handleChecked(row.customer_id)}
                        />
                    ),
                    width: "52px",
                    id: "select",
                },
            ]
            : []),

        {
            name: 'Signed-Up Date',
            selector: row => row.signed_up_date || "-",
            cell: (row) => <>{row.signed_up_date || "-"}</>,
            format: row => row.signed_up_date,
            sortable: true,
            width: "180px",
            id: "signed_up_date",
        },
        {
            name: 'Customer ID',
            selector: row => row.customer_id || "-",
            cell: (row) => <span className='e-text-blue-violet text-truncate text-decoration-hover-underline cursor-pointer'
                onClick={() => _handleDetail(row.customer_id)}>
                {row.rayi_customer_id || "-"}
            </span>,
            width: "125px",
            sortable: true,
            id: "customer_id",
        },
        {
            name: 'Name',
            selector: row => row.name,
            cell: (row) =>
                <span title={row.name} className='e-text-blue-violet text-truncate text-decoration-hover-underline cursor-pointer '
                    onClick={() => _handleDetail(row.customer_id)}>
                    {row.name || "-"}
                </span>,
            width: "260px",
            sortable: true,
            id: "name",
        },
        {
            name: 'Customer Type',
            selector: row => row.customer_type || "-",
            width: "120px",
            id: "customer_type",
        },
        {
            name: 'Customer Category',
            selector: row => row.customer_category || "-",
            cell: row => <span className='text-truncate' title={row.customer_category}>{row.customer_category || "-"}</span>,
            width: "160px",
            id: "customer_category",
        },
        {
            name: <span className="e-table-th-wrap">Signed-Up<br />Status</span>,
            selector: row => row.signed_up_status || "-",
            cell: row => <span className='text-truncate d-block' title={row.signed_up_status || undefined}>{row.signed_up_status || "-"}</span>,
            width: "240px",
            id: "signed_up_status",
        },

        {
            name: 'KYC Submitted Date',
            selector: row => row.kyc_submitted_date || "-",
            cell: (row) => <>{row.kyc_submitted_date || "-"}</>,
            width: "170px",
            format: row => row.kyc_submitted_date,
            sortable: true,
            id: "kyc_submitted_date",
        },
        {
            name: 'KYC Status',
            selector: row => row.kyc_status || "-",
            width: "130px",
            id: "kyc_status",
        },
        {
            name: 'KRA Status',
            cell: row => <>{row.kra_status || "-"}</>,
            width: "130px",
            id: "kra_status",
        },


        {
            name: 'Email',
            cell: (row) =>
                <a title={row.email} href={`mailto:${row.email}`} target='_blank' className='e-text-smoky-black text-decoration-none text-truncate text-decoration-hover-underline'>
                    {row.email}
                </a>,
            width: "240px",
            id: "email",
        },
        {
            name: 'Phone number',
            cell: (row) => <>
                {
                    row.phone_number ?
                        <a href={`tel:${row.phone_number}`} className='text-truncate e-text-smoky-black text-decoration-none text-decoration-hover-underline'>
                            {row.phone_number}
                        </a>
                        :
                        <>
                            -
                        </>
                }
            </>,
            width: "160px",
            id: "phone_number",
        },
        {
            name: 'AUM',
            selector: row => row.aum,
            width: "130px",
            sortable: true,
            sortFunction: (a, b) => {
                const numA = Number(a.aum.replace(/[^0-9.-]+/g, "")) || 0;
                const numB = Number(b.aum.replace(/[^0-9.-]+/g, "")) || 0;
                return numA - numB;
            },
            cell: row => (
                <span className='text-truncate' title={row.aum}>{row.aum || "-"}</span>
            ),
            id: "aum",
        },
        {
            name: 'FP Customer ID',
            selector: row => row.fp_customer_id || "-",
            cell: row => <span className='text-truncate' title={row.fp_customer_id}>{row.fp_customer_id || "-"}</span>,
            width: "340px",
            id: "fp_customer_id",
        },
        // {
        //     name: 'KYC Category',
        //     selector: row => row.kyc_category || "-",
        //     width: "150px",
        // },
        {
            name: 'User status',
            cell: (row) =>
                <>
                    {row.is_deleted === true ?
                        <Chip label={"Deleted"}
                            className={"e-text-dark-gray e-bg-pale-pink"} />
                        :
                        "-"
                    }
                </>,
            width: "120px",
            id: "user_status",
        },
        {
            name: 'Ticket number',
            selector: row => row.ticket_number || "-",
            cell: row => <span className='text-truncate' title={row.ticket_number}>{row.ticket_number || "-"}</span>,
            width: "140px",
            id: "ticket_number",
        },
        // {
        //     name: 'Whatsapp opt-in',
        //     selector: row => row.whatsapp_opt_in?row.whatsapp_opt_in===true?"Enabled":"Disabled":"-",
        //     cell: row => <>{row.whatsapp_opt_in?row.whatsapp_opt_in===true?"Enabled":"Disabled":"-"}</>,
        //     width: "140px",
        // },
        // {
        //     name: 'Email opt-in',
        //     selector: row => row.email_marketing_consent?row.email_marketing_consent===true?"Enabled":"Disabled":"-",
        //     cell: row => <>{row.email_marketing_consent?row.email_marketing_consent===true?"Enabled":"Disabled":"-"}</>,
        //     width: "120px",
        // },
        {
            name: 'Last Status Updated',
            selector: row => row.kyc_succeeded_at || "-",
            cell: row => <span className='text-truncate' title={row.kyc_succeeded_at}>{row.kyc_succeeded_at || "-"}</span>,
            width: "180px",
            id: "last_status_updated",
        },
    ];

    // user group column
    const USER_GROUP_COLUMN = [
        {
            name: 'User group name',
            selector: row => row.name,
            cell: row => <>{row.name}</>,
            width: "280px",
            sortable: true,
        },
        {
            name: 'Total users added',
            selector: row => row.customer_count || "-",
            width: "160px",
            sortable: true,
        },
        {
            name: '',
            cell: (row) =>
                <span className='cursor-pointer e-text-blue-violet text-decoration-hover-underline e-font-14 e-font-weight-500 line-height-18px'
                    onClick={() => navigate("group-detail", {
                        state: {
                            group_id: row.id,
                            group_name: row.name
                        }
                    })}>
                    View users
                </span>,
            width: "130px"
        },
        {
            name: '',
            cell: (row) =>
                <span className='cursor-pointer e-text-blue-violet text-decoration-hover-underline e-font-14 e-font-weight-500 line-height-18px'
                    onClick={() => _handleAddUsers(row, row.users)}>
                    Add users
                </span>,
            width: "130px"
        },

        {
            name: '',
            cell: (row) =>
                <span className='cursor-pointer e-text-blue-violet text-decoration-hover-underline e-font-14 e-font-weight-500 line-height-18px'
                    onClick={() => {
                        setDeleteModal(true);
                        setDeleteId(row.id);
                    }}>
                    Delete
                </span>,
            width: "130px"
        },
    ];

    // handle proof document
    const _handleProofDocument = (row) => {
        setProofModal(true);
        setSelectedRow(row);
    };

    const BANK_VERIFICATION_LIST = [
        {
            name: 'Customer ID',
            selector: row => row.customer_id || "-",
            cell: (row) => <span className='e-text-blue-violet text-truncate text-decoration-hover-underline cursor-pointer d-block'
                title={row.rayi_customer_id || undefined}
                onClick={() => _handleDetail(row.customer_id)}>
                {row.rayi_customer_id || "-"}
            </span>,
            width: "100px",
            sortable: true,
            id: "bv_customer_id",
        },
        {
            name: 'Name',
            selector: row => row.name || "-",
            cell: (row) =>
                <span className='e-text-blue-violet text-decoration-hover-underline cursor-pointer text-truncate d-block'
                    title={row.name || undefined}
                    onClick={() => _handleDetail(row.customer_id)}>
                    {row.name || "-"}
                </span>,
            width: "250px",
            sortable: true,
            id: "bv_name",
        },
        {
            name: 'KYC verification status',
            cell: (row) =>
                <>
                    {row.kyc_verification_status ?
                        <Chip label={row.kyc_verification_status}
                            className={row.kyc_verification_status.toLowerCase() === "verified" ? "e-bg-light-green e-text-dark-gray " : "e-text-dark-gray e-bg-pale-pink"} />
                        :
                        "-"
                    }
                </>,
            width: "180px",
            id: "bv_kyc_status",
        },
        {
            name: 'Account type',
            selector: row => row.account_type || "-",
            width: "140px",
            id: "bv_account_type",
        },
        {
            name: 'Account details',
            cell: (row) => {
                const details = `A/C No: ${row.account_number || "-"}, ${row.bank_name ?? ""}${row.ifsc ? `, IFSC code: ${row.ifsc}` : ""}`;
                return (
                    <div className='text-truncate' title={details}>
                        <span>A/C No: {row.account_number || "-"},</span>{" "}
                        <span>{row.bank_name ?? ""}{row.ifsc ? "," : ""}</span>
                        {row.ifsc && <span> IFSC code: {row.ifsc}</span>}
                    </div>
                );
            },
            width: "300px",
            id: "bv_account_details",
        },
        {
            name: 'PV ID',
            selector: row => row.pv_id || "-",
            cell: row => <span className='text-truncate d-block' title={row.pv_id || undefined}>{row.pv_id || "-"}</span>,
            width: "320px",
            id: "bv_pv_id",
        },
        {
            name: 'Document sent to FP',
            selector: row => row.document_sent_to_fp ? "Yes" : "No",
            width: "160px",
            id: "bv_doc_sent",
        },
        {
            name: 'Document sent timestamp',
            selector: row => row.document_sent_timestamp || "-",
            cell: row => <span className='text-truncate d-block' title={row.document_sent_timestamp || undefined}>{row.document_sent_timestamp || "-"}</span>,
            format: row => row.document_sent_timestamp,
            sortable: true,
            width: "200px",
            id: "bv_doc_timestamp",
        },

        {
            name: 'Bank verification status',
            cell: (row, index) =>
                <>
                    {row.status ?
                        <Chip label={row.status}
                            tooltip={(row.status === "Rejected" && row.reason !== null) ? true : false}
                            content={row.status === "Rejected" ? row.reason : ""}
                            id={`${row.rayi_customer_id}-${row.pv_id || index}`}
                            className={row.status.toLowerCase() === "accepted" ? "e-bg-green-crayola" :
                                row.status.toLowerCase() === "rejected" ? "e-bg-maximum-red " :
                                    row.status.toLowerCase() === "pending" ? "e-bg-marigold" : "e-bg-bleu-de-france"} />
                        : "-"}
                </>
            ,
            width: "180px",
            id: "bv_status",
        },
        {
            name: 'Bank proof',
            cell: (row) =>
                <TextButton name='View details'
                    fontWeight='e-font-weight-400'
                    className='text-decoration-hover-underline '
                    onClick={() => _handleProofDocument(row)} />,
            width: "120px",
            id: "bv_proof",
        },
        // {
        //     name: '',
        //     cell: (row) =>
        //         row?.status?.toLowerCase() === "pending" ? (
        //             <span className='e-text-blue-violet text-decoration-hover-underline cursor-pointer'
        //                 onClick={() => _handleAccept(row)}>
        //                 Accept
        //             </span>
        //         ) : null,
        //     width: "100px"
        // },
        // {
        //     name: '',
        //     cell: (row) =>
        //         row?.status?.toLowerCase() === "pending" ? (
        //             <span className='e-text-blue-violet text-decoration-hover-underline cursor-pointer'
        //                 onClick={() => _handleReject(row)}>
        //                 Reject
        //             </span>
        //         ) : null,
        //     width: "100px"
        // },

    ];

    // API - Get login otp
    const _filterData = () => {
        setFilterLoader(true);
        let is_post = false;
        let url = 'user/filter-data';
        APIService(is_post, url).then((response) => {
            if (response.status_code === 200) {
                setFilterData(response.data);

                if (state?.toggle !== true) {
                    setCustomerCategory(response.data?.customer_category[0]);
                    setCustomerType(response.data?.customer_type[0]);
                    // setKycCategory(response.data?.kyc_category[0]);
                    setSelectedKycStatus(response.data?.kyc_status[0]);
                }
            } else {
                setFilterData([]);
            }
            setFilterLoader(false);
        });
    };


    // API -  user listing
    const _userList = (page_num = currentPage, search = searchValue) => {

        const formatted_start_date = selectedDate === null ? null : format(new Date(selectedDate[0]), 'dd-MM-yyyy');
        const formatted_end_date = selectedDate === null ? null : format(new Date(selectedDate[1]), 'dd-MM-yyyy');

        let is_post = true;
        let url = 'user/list';
        let request = {
            "query": search,
            "page_num": page_num,
            "page_size": ITEMS_PER_PAGE,
            "customer_category": customerCategory !== null ? customerCategory?.value : null,
            "customer_type": customerType !== null ? customerType?.value : null,
            // "kyc_category": kycCategory !== null ? kycCategory?.value : null,
            "kyc_status": selectedKycStatus !== null ? selectedKycStatus?.value : null,
            "kyc_submitted_start_date": formatted_start_date,
            "kyc_submitted_end_date": formatted_end_date
        }

        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setListData(response.data);
            } else {
                setListData({});
            }
            setLoader(false);
        });
    };

    // API - Bank verification approve
    const _bankVerificationApprove = () => {
        let is_post = true;
        let url = 'user/approve-bank-verification';
        let request = {
            "customer_id": selectedRow.customer_id,
            "bank_id": selectedRow.bank_id
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setAcceptModal(false);
                _bankVerificationList(1);
            } else {
                toast.dismiss();
                toast.success(response.message, { type: "error" });
            }
        })
    };

    // API - Bank verification reject
    const _bankVerificationReject = (note) => {
        let is_post = true;
        let url = 'user/reject-bank-verification';
        let request = {
            "customer_id": selectedRow.customer_id,
            "bank_id": selectedRow.bank_id,
            "rejection_reason": note
        }
        setRejectLoader(true);
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setRejectSuccess(true);
                toast.dismiss();
                toast.success("Successfully rejected", { type: "success" });
                _bankVerificationList(1);
            } else {
                toast.dismiss();
                toast.error(response.message, { type: "error" });
            }
            setRejectLoader(false);
        })
    };

    // API - Download list customers
    const _downloadList = () => {
        const formatted_start_date = selectedDate === null ? null : format(new Date(selectedDate[0]), 'dd-MM-yyyy');
        const formatted_end_date = selectedDate === null ? null : format(new Date(selectedDate[1]), 'dd-MM-yyyy');

        let is_post = true;
        let url = 'user/customer-download ';
        let request = {
            "query": searchValue,
            "customer_category": customerCategory !== null ? customerCategory?.value : null,
            "customer_type": customerType !== null ? customerType?.value : null,
            // "kyc_category": kycCategory !== null ? kycCategory?.value : null,
            "kyc_status": selectedKycStatus !== null ? selectedKycStatus?.value : null,
            "kyc_submitted_start_date": formatted_start_date,
            "kyc_submitted_end_date": formatted_end_date
        }
        setDownloadLoader(true);
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                // window.open(response.data.url, '_blank');

                // const url = response.data.url;
                // const link = document.createElement('a');
                // link.href = url;
                // link.download = ''; // Optional: specify a file name
                // document.body.appendChild(link);
                // link.click();
                // document.body.removeChild(link);
                toast.dismiss();
                toast.success("Download request submitted successfully. You'll receive the report via email once it's generated.", { type: "success" })

                setChecked([]);
            } else {
                toast.dismiss();
                toast.success(response.message, { type: "error" })
            }
            setDownloadLoader(false);
        })
    };


    // API - Create user group
    const _createGroup = (group_name = groupName) => {
        setButtonLoader(true);

        // if (checked.length === 0) {
        //     toast.dismiss();
        //     toast.error("Please add users before creating group manually.", { type: "error" });
        //     setButtonLoader(false);
        //     return;
        // }


        let is_post = true;
        let url = 'user/add-user-group';
        let request = {
            "type": 1,
            "file": null,
            "customer_ids": isSelectAll ? [] : checked,
            "name": group_name
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setConfirmStatus(true);
                setCreateGroupSuccess(true);

            } else {
                toast.dismiss();
                toast.error(response.message, { type: "error" });
            }
            setButtonLoader(false);
        })
    };

    // API - Get group list
    const _listGroup = (page_num = groupCurrentPage) => {
        let is_post = true;
        let url = 'user/user-groups';
        let request = {
            "page_num": page_num,
            "page_size": ITEMS_PER_PAGE,
            "query": "",
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setGroupData(response.data);
            } else {
                setGroupData({ data: [] });
            }
            setUserGroupLoader(false);
        })
    };

    // API - Add users in group
    const _addUsers = (user) => {

        let updated_user_ids = [];
        updated_user_ids = user?.map(item => item.id);


        if (updated_user_ids.length === 0) {
            toast.dismiss();
            toast.error("Select at least one user", { type: "error" });
            return;
        }

        let is_post = true;
        // let url = 'send-email/add-users';
        let url = 'user/add-user-group';
        let request = {
            "group_id": userGroupId,
            "type": 1,
            "customer_ids": updated_user_ids

            // "type": 1,
            // "file": null,
            // "customer_ids": checked,
            // "name": group_name
        }

        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setConfirmStatus(true);
                setCreateGroupSuccess(true);
                setSuccessMessage(response.message);
            } else {
                toast.dismiss();
                toast.success(response.message, { type: "error" });
            }
        })
    };

    // API - Bank verification list filter data
    const _verificationFilterData = () => {
        setVerificationFilterLoader(true);
        let is_post = false;
        let url = 'user/bank-verification-filter-data';
        APIService(is_post, url).then((response) => {
            if (response.status_code === 200) {
                setVerificationFilterData(response.data);

                setSelectedStatus(response.data.status[0]);

                setSelectedUserType(response.data.nri_status[0]);

            } else {
                setVerificationFilterData({});
            }
            setVerificationFilterLoader(false);
        });
    };


    // API - Bank verification list data
    const _bankVerificationList = (page_num = currentPage, search = searchValue) => {
        setLoader(true);
        let is_post = true;
        let url = 'user/list-bank-verification';
        let data = {
            "status": selectedStatus?.value || null,
            "nri_status": selectedUserType !== null ? selectedUserType.value : null,
            "query": search,
            "page_num": page_num,
            "page_size": ITEMS_PER_PAGE,
        }

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setListData(response.data);
            } else {
                setListData({});
            }
            setLoader(false);
        });
    };

    // API - Delete user group
    const _deleteGroup = () => {
        setDeleteLoader(true);
        let is_post = true;
        let url = 'user/delete-user-group';
        let request = {
            "group_id": deleteId
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setDeleteStatus(true);
            } else {
                toast.dismiss();
                toast.success(response.message, { type: "error" });
            }
            setDeleteLoader(false);
        })
    };

    return (
        <>
            <section className='e-section-height pb-5 e-bg-magnolia' >
                <div className='e-bg-lavender padding-52px-lr pt-2 padding-80px-bottom'>
                    <h3 className='margin-32px-bottom e-text-chinese-black e-primary-font e-font-24 e-font-weight-600 line-height-24px'>
                        Customers
                    </h3>
                </div>

                <div className='padding-52px-lr margin--80px-top'>
                    <div ref={scrollRef} className='e-bg-ghost-white border-radius-16  '>
                        <div className='padding-32px-lr padding-32px-top'>

                            <CustomTab data={tabTitles}
                                selectedTab={selectedTab}
                                handleClick={_handleTab} />

                            <div className='pt-4 pb-2 d-flex align-items-center justify-content-end pb- gap-16px flex-wrap'>
                                <div className='d-flex align-items-center gap-4'>
                                    {selectedTab === 1 ?
                                        <div className='d-flex align-items-center gap-4'>
                                            {groupName.length !== 0 &&
                                                <PrimaryButton name="Create"
                                                    disabled={false}
                                                    loader={buttonLoader}
                                                    className={buttonLoader ? "w-87px" : ""}
                                                    paddingBlock='padding-12px-tb px-4'
                                                    onClick={() => _handleCreate()} />
                                            }

                                            {hasCustomerDownloadAccess &&
                                                <SecondaryButton name="Download List"
                                                    disabled={loader || listData?.data?.length === 0 ? true : false}
                                                    loader={downloadLoader}
                                                    className={downloadLoader ? "w-129px h-42px" : ""}
                                                    onClick={_downloadListUser} />
                                            }


                                        </div>
                                        :
                                        selectedTab === 2 ?
                                            <div className='d-flex align-items-center gap-4'>
                                                <SecondaryButton name="Create user groups"
                                                    disabled={false}
                                                    paddingBlock='padding-12px-tb padding-16px-lr'
                                                    onClick={() => _handleCreateGroup(1)} />
                                            </div>
                                            :
                                            null
                                    }


                                    {(selectedTab === 1 || selectedTab === 3) &&
                                        <>
                                            <CustomSearchInput placeholder={selectedTab === 1 ? "Search with user’s name, email, mobile number or customer ID"
                                                : "Search with customer ID, name or A/C No."}
                                                type="text"
                                                value={searchValue}
                                                onSearch={() => _onSearch()}
                                                onClear={_handleSearchClear}
                                                onSearchClear={_handleSearchClear}
                                                className={"w-340px"}
                                                onKeyPress={() => _onSearch()}
                                                handleChange={(e) => {
                                                    setSearchValue(e);
                                                    if (e.length === 0) {
                                                        _handleSearchClear()
                                                    }
                                                }} />
                                            <div className={` padding-10px-all border-radius-8 e-cursor-pointer e-border-1px-light-purple cursor-pointer   ${filterBtn ? ' e-bg-blue-violet ' : ''}`}
                                                onClick={_handleFilter}>
                                                <Icon icon='filter'
                                                    size='1.25rem'
                                                    className='d-flex'
                                                    color={filterBtn && color.white} />
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>


                        {selectedTab === 2 ?
                            // User group list
                            <>
                                {userGroupLoader === true ?
                                    <div className='d-flex align-items-center min-vh-50 justify-content-center'>
                                        <img src={require("../../Assets/Image/loader.gif")}
                                            draggable={false}
                                            width={80}
                                            height={80}
                                            alt='loader'
                                            className='text-center' />
                                    </div>
                                    :
                                    groupData?.data?.length !== 0 ?
                                        <div className='e-data-table-wrapper-default-updated pt- padding-32px-bottom'>
                                            <CustomDataTable columns={USER_GROUP_COLUMN}
                                                data={groupData.data}
                                                pagination={true}
                                                paginationPerPage={ITEMS_PER_PAGE}
                                                paginationDefaultPage={groupData.current_page}
                                                paginationTotalRows={groupData.total_count}
                                                lastPage={groupData.total_page}
                                                onChangePage={_handleGroupTablePageChange}
                                            />
                                        </div>
                                        :
                                        <EmptyScreen
                                            image={require('../../Assets/Image/NotFound/no-data.png')}
                                            title='No results found'
                                            description={`We couldn' t find anything that matches your search. Try checking your spelling, using different keywords, or exploring popular funds.`}
                                        />
                                }
                            </>
                            :
                            <>
                                <div className={`e-filter-content  ${filterBtn ? 'expanded ' : 'e-overflow collapsed'}`}>
                                    <div className='e-bg-main-white pt-3 pb-4 padding-32px-lr'>
                                        <div className='d-flex justify-content-end'>
                                            <TextButton name="Clear all"
                                                onClick={_handleClear}
                                            />
                                        </div>
                                        {selectedTab === 1 ?
                                            <div className='d-flex gap-4 '>

                                                <CustomSelectBox
                                                    title={"Customer category"}
                                                    placeholder='Select'
                                                    controlWidth='11rem'
                                                    loader={filterLoader}
                                                    options={filterData?.customer_category}
                                                    isSearchable={false}
                                                    value={customerCategory}
                                                    onChange={(value) => setCustomerCategory(value)} />

                                                <CustomSelectBox
                                                    title={"Customer type"}
                                                    placeholder='Select'
                                                    controlWidth='11rem'
                                                    options={filterData?.customer_type}
                                                    isSearchable={false}
                                                    value={customerType}
                                                    loader={filterLoader}
                                                    onChange={(value) => setCustomerType(value)} />

                                                <CustomSelectBox
                                                    title={"KYC status"}
                                                    placeholder='Select'
                                                    controlWidth='11rem'
                                                    options={filterData?.kyc_status}
                                                    isSearchable={false}
                                                    loader={filterLoader}
                                                    value={selectedKycStatus}
                                                    onChange={(value) => setSelectedKycStatus(value)} />


                                                <DateRangePicker label="KYC submitted Date"
                                                    placeholder="Select"
                                                    calendarWrapperClass="end-0"
                                                    value={selectedDate}
                                                    maxDate={new Date}
                                                    handleClear={() => setSelectedDate(null)}
                                                    handleChange={(date) => setSelectedDate(date)} />
                                            </div>

                                            :
                                            selectedTab === 3 ?
                                                <div className='d-flex align-items-center gap-4'>
                                                    <CustomSelectBox
                                                        title={'Status'}
                                                        placeholder='Select'
                                                        width='15rem'
                                                        options={verificationFilterData.status}
                                                        loader={verificationFilterLoader}
                                                        isSearchable={false}
                                                        value={selectedStatus}
                                                        onChange={(value) => setSelectedStatus(value)} />

                                                    <CustomSelectBox
                                                        title={'Resident Type'}
                                                        placeholder='Select'
                                                        width='15rem'
                                                        options={verificationFilterData.nri_status}
                                                        loader={verificationFilterLoader}
                                                        isSearchable={false}
                                                        value={selectedUserType}
                                                        onChange={(value) => setSelectedUserType(value)} />
                                                </div>
                                                :
                                                null
                                        }
                                        <div className='pt-4 mt-2'>
                                            <PrimaryButton name='Filter now'
                                                paddingBlock='padding-12px-tb padding-40px-lr'
                                                onClick={_handleFilterSelected} />
                                        </div>
                                    </div>
                                </div>

                                <div className='pt- padding-32px-lr d-flex gap-1 align-items-center justify-content-end'>
                                    <div>
                                        <img src={require("../../Assets/Image/scroll-animation.gif")}
                                            draggable={false}
                                            className='e-rotate-270'
                                            width={24}
                                            height={24}
                                            alt='scroll' />
                                    </div>
                                    <p className='mb-0 e-text-bleu-de-france e-alt-font e-font-12 e-font-weight-500 line-height-14px'>
                                        Scroll horizontally for view more  information
                                    </p>
                                </div>

                                {loader === true ?
                                    <div className='d-flex align-items-center min-vh-50 justify-content-center'>
                                        <img src={require("../../Assets/Image/loader.gif")}
                                            draggable={false}
                                            width={80}
                                            height={80}
                                            alt='loader'
                                            className='text-center' />
                                    </div>
                                    :
                                    Object.keys(listData).length !== 0 && listData?.data?.length !== 0 ?
                                        <div className={`e-data-table-wrapper-default-updated pt-3 padding-32px-bottom`}>
                                            <CustomDataTable columns={selectedTab === 1 ? ALL_CUSTOMER : BANK_VERIFICATION_LIST}
                                                data={listData.data}
                                                pagination={true}
                                                paginationPerPage={ITEMS_PER_PAGE}
                                                paginationDefaultPage={listData.current_page}
                                                paginationTotalRows={listData.total_count}
                                                lastPage={listData.total_page}
                                                onChangePage={_handleTablePageChange}
                                            // rowClick={(row) => _handleDetail(row.customer_id, row.name)}
                                            />
                                        </div>
                                        :
                                        <EmptyScreen
                                            image={require('../../Assets/Image/NotFound/no-data.png')}
                                            title='No results found'
                                            description={`We couldn' t find anything that matches your search. Try checking your spelling, using different keywords, or exploring popular funds.`}
                                        />
                                }
                            </>
                        }
                    </div>
                </div >
            </section >

            {proofModal === true &&
                <ViewDetailModal
                    data={selectedRow}
                    handleClose={() => {
                        setProofModal(false);
                    }}
                />
            }

            {/*  accept modal */}
            {
                acceptModal === true &&
                <AcceptModal
                    data={selectedRow}
                    handleConfirm={() => _bankVerificationApprove()}
                    handleClose={() => {
                        setAcceptModal(false);
                    }}

                />
            }

            {/* reject modal */}
            {rejectModal === true &&
                <RejectModal
                    data={selectedRow}
                    status={rejectSuccess}
                    loader={rejectLoader}
                    handleConfirm={(note) => _bankVerificationReject(note)}
                    handleClose={() => {
                        setRejectModal(false);
                        setRejectSuccess(false);
                    }}
                />
            }

            {createGroupModal === true &&
                <CreateUserGroup type={createGroupType}
                    groupType={groupType}
                    group_id={userGroupId}
                    confirmStatus={confirmStatus}
                    loader={buttonLoader}
                    selectedUsers={selectedUsers}
                    handleClose={() => {
                        setTimeout(() => {
                            setCreateGroupModal(false);
                            setGroupType(1);
                            setGroupName("");
                            setCreateGroupType(1);
                        }, 200);
                    }}

                    handleContinue={_handleContinue}
                    handleSuccess={(message) => {
                        setTimeout(() => {
                            setCreateGroupModal(false);
                            setCreateGroupSuccess(true);
                        }, 200);
                        setSuccessMessage(message);
                    }}
                />
            }

            {createGroupSuccess === true &&
                <SuccessModal title="Success!"
                    description={successMessage ? successMessage : "Group created successfully. Customers have been added to the group."}
                    handleSuccess={() => {
                        setTimeout(() => {
                            setCreateGroupSuccess(false);
                            setCreateGroupModal(false);
                            setConfirmStatus(false);
                            setCreateGroupType(1);
                            setGroupName("");
                        }, 200);

                        if (selectedTab === 2) {
                            _listGroup(1);
                            setUserGroupLoader(true);
                        } else {
                            navigate(state?.path ? state.path : "/customers", {
                                state: {
                                    tab_index: 2,
                                    type: "user_group",
                                    group_name: ""
                                }
                            });
                            setChecked([]);
                            setGroupName("");
                            setCreateGroupSuccess(false);
                            setCreateGroupModal(false);
                            setCreateGroupType(1);
                        }
                    }} />
            }


            {deleteModal === true &&
                <ConfirmModal title={deleteStatus ? "Confirm successfully" : "Confirm group deletion"}
                    description={deleteStatus ? "The group has been deleted successfully." : "Are you sure you want to delete this group? This action cannot be undone."}
                    status={deleteStatus}
                    loader={deleteLoader}
                    handleClose={() => {
                        setTimeout(() => {
                            setDeleteModal(false);
                            setDeleteStatus(false);
                            setDeleteId(null);
                        }, 200);
                    }}
                    handleConfirm={_deleteGroup}
                    handleSuccess={() => {
                        setTimeout(() => {
                            setDeleteStatus(false);
                            setDeleteModal(false);
                            setDeleteId(null);

                            _listGroup(1);
                            setUserGroupLoader(true);
                        }, 200);
                    }} />
            }
        </>
    )
}

export default List;